import { useState } from "react";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { setTopicsStoreOne } from "..";
import { capitalize } from "../../../../../common/helpers";
import { ITopic } from "../../../../../common/types";

export const Topic = ({ topic }: { topic: ITopic }) => {
  const [isSelected, setIsSelected] = useState<boolean>(false);

  const handleClick = (e: React.PointerEvent<HTMLButtonElement>) => {
    if (isSelected) {
      setIsSelected(false);
      setTopicsStoreOne("searchingTopics", (topics) =>
        topics.filter((el) => el !== topic.title.toLowerCase())
      );
    } else {
      setIsSelected(true);
      setTopicsStoreOne("searchingTopics", (topics) => [
        ...topics,
        topic.title.toLowerCase(),
      ]);
    }
  };

  return (
    <TopicButton onClick={handleClick} isSelected={isSelected}>
      {capitalize(topic.title)}
    </TopicButton>
  );
};

const TopicButton = styled.button(({ isSelected }: { isSelected: boolean }) => [
  tw`border-[1px] rounded-2xl border-pink-400 text-pink-600`,
  css`
    font-size: 0.4rem;
    padding: 0.1rem 0.4rem;
    height: min-content;
  `,
  isSelected && tw`text-white bg-pink-600`,
]);
